import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {APIClient} from "../../../helpers/ApiHelper";


export const findVeloxityDevices = createAsyncThunk(
    "findVeloxityDevices",
    async ({ deviceId }) => {
        try {
            const queryParams = {};
            queryParams.clientDeviceId = deviceId;
            const apiClient = new APIClient();
            const response = await apiClient.get("/api/v1/information/device-find",queryParams);

            return response.data;
        } catch (error) {
            throw error;
        }
    }
);



export const veloxityFindDevicesSlice = createSlice({
    name: "VeloxityFindDevices",
    initialState: {
        loading: true,
        clientDeviceIds: [],
        clientDeviceId: "",
        deviceModel: "",
        gender: "",
        osType: "",
        personaName: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(findVeloxityDevices.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(findVeloxityDevices.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.items.length !== 0){
                state.clientDeviceId = action.payload.items[0].clientDeviceId;
                state.deviceModel = action.payload.items[0].deviceModel;
                state.gender = action.payload.items[0].gender;
                state.osType = action.payload.items[0].osType;
                state.personaName = action.payload.items[0].personaName;
            }

            state.clientDeviceIds = action.payload.items.map(
                (item) => item.clientDeviceId
            );
        });
        builder.addCase(findVeloxityDevices.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export default veloxityFindDevicesSlice.reducer;